import React, {useState, useEffect} from 'react';
import {gql} from 'apollo-boost';
import {get, findIndex, orderBy} from 'lodash';
import styled from 'styled-components';
import {isWidthUp} from '@material-ui/core/withWidth';
import {Grid, Box, ButtonBase} from '@material-ui/core';
import produce from 'immer';
import qs from 'qs';
import { v4 as uuidv4 } from 'uuid';
import ReactHtmlParser from 'react-html-parser';
import withWidth from '../../src/components/hoc/withWidth';
import {theme} from '../../src/themes/default-theme'
import client from '../../src/graphql/client';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorCompareData from '../../src/data-restructure/pages/compare';
import getFloorplanSize from '../../src/util/getFloorplanSize';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import {getItems, saveItem, removeItem} from '../../src/util/savedCaravans';
import {filterOverlayProps} from '../../src/data-restructure/ui/model-overlay';
import triggerLsEvent from '../../src/util/triggerLsEvent';
import {ReactSVG} from 'react-svg';
import getPriceKey from '../../src/util/getPriceKey';
import PostcodePopup from '../../src/components/ui/SimplePostcodePopup';
import seoQuery from '../../src/graphql/queries/seo';
// Components
import Text from '../../src/components/typography';
import Tabs from '../../src/components/ui/Tabs';
import CaravanFilter from '../../src/components/filters/CaravanFilter';
import CompareTable from '../../src/containers/Compare/CompareTable';
import Cta from '../../src/components/ui/Cta';
import SocialShare from '../../src/components/ui/SocialShare';
import dynamic from 'next/dynamic';
import dlPush from '../../src/util/dlPush';
import ModelSelectModal from '../../src/components/ui/ModelSelectModal';
import blank from '../../src/assets/blank-caravan.png';
import enlargeIcon from '../../src/assets/icons/enlarge.svg';
import chevronRightIcon from '../../src/assets/icons/chevron-right-white.svg';
import close from '../../src/assets/icons/close.svg';
import Links from '../../src/components/ui/Links';

const Checkbox = dynamic(() => import('../../src/components/forms/Checkbox'), {
  ssr: false
});

const Container = styled.div`
  background-color: ${theme.palette.lightGrey};
  padding-top: 48px;

  &:before,
  &:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }

  ${theme.props.desktopNavUp} {
    padding-top: 114px;
  }

  ${theme.breakpoints.up('lg')} {
    padding-top: 160px;
  }
`

const TabsWrapper = styled.div`
  margin: 5px 0 0;

  ${theme.breakpoints.up('lg')} {
    margin-top: 15px;
  }
`

const TabsContainer = styled.div`
  margin-top: 25px;
  display: inline-block;
  max-width: 100%;
`

const CaravanCardContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;

`

const CaravanCardItem = styled.div `
  text-align: left;
  width: 280px;
  border-left: 1px solid ${theme.palette.middleGrey};

  &:last-child {
    border-right: 1px solid ${theme.palette.middleGrey};
  }

  ${theme.breakpoints.up('lg')} {
    width: 345px;
  }

  ${theme.breakpoints.down('sm')} {
    width: 50%;
    &:first-child {
      width: calc(50% - 1px);
    }

    &:last-child {
      border-right: 0;
    }
    
    &:first-child {
      border-left: 0;
    }
  }
`

const Blank = styled.div`
  position: relative;
  padding: 0 8px;

  img {
    padding: 15px 0;
    max-width: 300px;
    height: auto;
    width: 90%;
    margin: 0 auto;
    display: block;
  }

  ${theme.breakpoints.up('md')} {
    padding: 0 16px;
    img {
      padding: 35px 30px;
    }
  }
`

const Edit = styled.div`
  position: relative;
  padding: 0 8px;

  ${theme.breakpoints.up('md')} {
    padding: 0 16px;
  }
`

const Add = styled.div`
  cursor: pointer;
  ${props => props.margin === 1 && `
    margin-top: 40px;
  `}
  span {
    display: inline-block;
    vertical-align: middle;
  }

  .svg-container {
    svg [fill]{
      fill:white;
    }
  }

  button {
    margin-right: 10px;
    &:hover {
      background-color: ${theme.palette.vividBlue};
    }
  }
`

const Close = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  ${theme.breakpoints.up('md')} {
    right: 12px;
  }

  button {
    padding: 5px;
  }

  svg {
    display: block;
    width: 14px;
    height: 14px;
    [stroke] {
      stroke: ${theme.palette.charcoal};
    }
  }
`

const CompareModels = styled.div`
  margin-top: 20px;

  ${props => props.itemLength === 3 && `
    margin: 0 auto;
  `}

  ${theme.breakpoints.up('lg')} {
    margin-bottom: 40px;
    margin-top: 60px;
  }
`

const CompareTableContainer = styled.div`
  max-width: 1432px;
  margin: 0 auto 100px;
`

const LinkItems = styled.div`
 
`

const CompareTableFooter = styled.div`
  ${props => props.mobile === 1 && `
    display: flex;
    width: 100%;
    margin-top: 10px;
  `}

  ${theme.breakpoints.up('md')} {
    display: table;
    width: 100%;
    margin-top: 10px;
  }
`

const CompareTableFooterCell = styled.div`
  width: 50%;
  text-align: center;

  ${props => props.fullWidth === 1 && `
    width: 100%;
    padding: 20px 0;
    margin-top: 10px;
    border-top: 1px solid ${theme.palette.middleGrey};
    border-bottom: 1px solid ${theme.palette.middleGrey};
  `}

  ${theme.breakpoints.up('md')} {
    width: 280px;
    display: table-cell;
    
    &:first-child {
      width: auto;
      text-align: left;
    }
  }

  ${theme.breakpoints.up('lg')} {
    width: 345px;
  }
`

const CompareTableFooterCta = styled.div`
  margin: 10px 0 20px;
  text-align: center;
`

const CompareTableCta = styled.div`
  margin-top: 20px;
`

const Compare = (props) => {
  const [compareItems, setCompareItems] = useState([]);
  const maxToCompare = isWidthUp('lg', props.width) ? 3 : 2;
  // const minToCompare = 2;
  // const [curWidth, updateCurWidth] = useState(props.width);
  // const [step, updateStep] = useState(1);
  const [modelView, setModelView] = useState(0);
  const [savedItems, setSavedItems] = useState([]);
  const [viewItems, setViewItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [modelsOfInterest, setModelsOfInterest] = useState([]);
  const [changeIndex, setChangeIndex] = useState(null);
  const [pricingModal, setPricingModal] = useState(false);
  const [pricingKey, setPricingKey] = useState(false);

  useEffect(() => {
    const qsData = qs.parse(window.location.search.replace('?',''));

    const newState = refactor(qsData);

    if (qsData && qsData.items) {
      setModelsOfInterest(newState);
      handleFilterChange(newState);
      return
    } else {
      const lsCompare = localStorage.getItem('compare');
      
      if (lsCompare) {
        const newData = JSON.parse(lsCompare);
        if (newData && newData.items) {
          const newRefactorData = refactor(newData);
          setModelsOfInterest(newRefactorData);
          handleFilterChange(newRefactorData);
          return
        }
      }
    }

    setModelsOfInterest([]);
    handleFilterChange([]);

  }, []);

  useEffect(() => {
    
    const key = getPriceKey();
    
    // Populate these items to specs
    if (!key) {
        setPricingModal(true);
    } else {
      setPricingKey(key);
    }
  },[])

  const refactor = (qsData) => {
    let newState = [];

    qsData && qsData.items && qsData.items.forEach((item, index) => {
      const itemRangeId = item.range;
      const itemSeriesId = item.series;
      const modelRange = props.modelOverlay.find(overlay => ((overlay.id && itemRangeId) && overlay.id.toString() === itemRangeId.toString() || (overlay.rangeId && itemRangeId) && overlay.rangeId.toString() === itemRangeId.toString()));
      const modelSeries = (modelRange && itemSeriesId) ? modelRange.models.find(overlay => (((overlay.id && itemSeriesId) && overlay.id.toString()) === itemSeriesId.toString()) || (((overlay.seriesId && itemSeriesId) && overlay.seriesId.toString()) === itemSeriesId.toString())) : null;
      var selectedModel;

      if (modelRange && !modelSeries) {
        selectedModel = get(modelRange, 'models[0].models[0]', null);
      } else {
        if (item.model) {
          selectedModel = modelSeries ? modelSeries.models.find(modelItem => modelItem.layoutId.toString() === item.model.toString() || modelItem.id.toString() === item.model.toString()) : null
        } else {
          selectedModel = modelSeries ? get(modelSeries, 'models[0]', null) : null
        }
      }

      if (selectedModel) {
        newState.push(selectedModel);
      }
    });

    return newState
  }

  const equalizeTitle = () => {
    const items = document.querySelectorAll('[data-equalize]');

    
    if (items.length > 0) {
      let heights = [];
      for (let i = 0; i < items.length; i++) {
        items[i].style.height = 'auto';
        heights.push(items[i].offsetHeight);
      }
      const tallest = Math.max(...heights);

      for (var i = 0; i < items.length; i++) {
        items[i].style.height = tallest + 'px';
      }
    }
  }

  useEffect(() => {
    window.addEventListener("resize", equalizeTitle);
    return () => window.removeEventListener("resize", equalizeTitle);
  },[])

  useEffect(() => {
    setSaved()
    document.addEventListener("ls:change", setSaved);
    return () => document.removeEventListener("ls:change", setSaved);
  },[])
  
  useEffect(() => {

    // Reset view items
    const newViewItems = compareItems.map(item => {
      return setViewObj(item);
    }).filter(item => {
      return findIndex(viewItems, item) !== -1
    })

    setViewItems(newViewItems);

  }, [compareItems])

  useEffect(() => {
    equalizeTitle();
  }, [viewItems])

  const setViewObj = (item) => {
    return {
      range: get(item, 'range', null) ? ReactHtmlParser(item.range)[0] : null,
      series: get(item, 'title', null) ? ReactHtmlParser(item.title)[0] : null,
      model: get(item, 'model.modelTitle', null) ? ReactHtmlParser(item.model.modelTitle)[0] : null,
    }
  }

  const updateFilters = (qsData, updatedIndex) => {

    let activeItems = [];
    // Loop through qs items first to prevent order from changing...

    qsData && qsData.items && qsData.items.forEach((qsItem, qsItemIndex) => {

      props.ranges.forEach((item, index) => {
        const rangeTitle = item.title;

        if (qsItem.range === item.id || qsItem.range === item.rangeId.toString()) {     

          // Then loop through series
          item.series.forEach((series, index) => {

            var spec = null;
            var specIndex;
            // Check if spec is in the query string. If not then set then set the spec to be the first in array
            series.specs && series.specs.forEach((specItem, index) => {
              if (qsItem.spec && qsItem.spec.toLowerCase().trim() === specItem.title.toLowerCase().trim()) {
                spec = specItem.title;
                specIndex = index;
              }
            });
            if (spec === null) {
              spec = get(series, 'specs[0].title', null);
              specIndex = 0;
            }
            // Using the spec above, check to see if model (floorplan / size) is in the url and exists within the spec
            var model = null;

            get(series, `specs[${specIndex}].models`, []).find((modelItem) => {

              if (qsItem.model && (qsItem.model === modelItem.layoutId || qsItem.model === modelItem.id)) {
                model = {
                  text: modelItem.layoutName ? getFloorplanSize(modelItem.layoutName) : modelItem.title,
                  name: modelItem.title,
                  value: modelItem.layoutId,
                  modelTitle: modelItem.modelTitle ? ReactHtmlParser(modelItem.modelTitle)[0] : null,
                  image: get(modelItem, 'image', null),
                  floorPlanImg: get(modelItem, 'floorPlanImg', null),
                  sleepsOptional: get(modelItem, 'sleepsOptional', null),
                  sleepsStandard: get(modelItem, 'sleepsStandard', null),
                  hidePricing: get(modelItem, 'hidePricing', null),
                  uri: get(modelItem, 'uri', null),
                }
              }
            })
            if (model === null) {

              model = {
                text: getFloorplanSize(get(series, `specs[${specIndex}].models[0].layoutName`, null)),
                name: get(series, `specs[${specIndex}].models[0].title`, null),
                value: get(series, `specs[${specIndex}].models[0].layoutId`, null),
                modelTitle: get(series, `specs[${specIndex}].models[0].modelTitle`, null) ? ReactHtmlParser(get(series, `specs[${specIndex}].models[0].modelTitle`, ''))[0] : null,
                image: get(series, `specs[${specIndex}].models[0].image`, null),
                floorPlanImg: get(series, `specs[${specIndex}].models[0].floorPlanImg`, null),
                sleepsOptional: get(series, `specs[${specIndex}].models[0].sleepsOptional`, null),
                sleepsStandard: get(series, `specs[${specIndex}].models[0].sleepsStandard`, null),
                hidePricing: get(series, `specs[${specIndex}].models[0].hidePricing`, null),
                uri: get(series, `specs[${specIndex}].models[0].uri`, null),
              };
            }
            
            if (series.id === qsItem.series || series.seriesId.toString() === qsItem.series) {
              activeItems.length < maxToCompare && activeItems.push({...series, spec, model, specIndex, uniqueId: uuidv4()});
            } 
          })
        }
      });
    });
    
    setCompareItems(activeItems);
  }

  // const updateParams = (compare) => {
  //   const compareData = compare.map(item => { return {
  //     range: item.rangeId,
  //     series: item.id
  //   }})
  //   const param = qs.stringify({items: compareData});
  //   window.history.pushState('', '', `?${param}`)
  // }

  // const handleBannerNext = (e) => {
  //   e.preventDefault();
  //   updateStep(2);
  // }

  // const refactorFloorplanSizes = (floorplans, range) => {
  //   let refactoredFloorplanSizes = [];
  //   let sizeCount = {};

  //   const floorPlanSizes = floorplans.map(item => {
  //     const layoutName = get(item, 'layoutName', null);
  //     const layoutId = get(item, 'layoutId', null);
  //     let layoutSizeName = undefined

  //     if (range.toLowerCase() === 'jayco j-pod' || range.toLowerCase() === 'camper trailers') {
  //       const splitName = get(item, 'layoutName', '').toLowerCase().split('.')[0]
  //       layoutSizeName = splitName.charAt(0).toUpperCase() + splitName.slice(1);
  //     }

  //     return {
  //       size: item.size ? item.size : getFloorplanSize(layoutSizeName || layoutName),
  //       layoutId,
  //       layoutName: layoutSizeName
  //     }
  //   })

  //   floorPlanSizes.forEach(item => {

  //     const hasSameSize = floorPlanSizes.filter(k => {
  //       return k.size === item.size
  //     }).length > 1
  //     if(hasSameSize) {
  //       get(sizeCount, `[${item.size}].count`, null) ? sizeCount[item.size].count ++ : sizeCount[item.size] = {count:1};
  //       refactoredFloorplanSizes.push({
  //         value: item.layoutId,
  //         text: `${item.size} - ${sizeCount[item.size].count}`,
  //       })
  //     } else {
  //       refactoredFloorplanSizes.push({
  //         value: item.layoutId,
  //         text: item.size,
  //       })
  //     }
  //   })

  //   return refactoredFloorplanSizes
  // }

  const setSaved = () => {
    const savedCaravans = get(window, 'localStorage.savedCaravans', null);
    if (savedCaravans && savedCaravans.length > 0) {
      const parsedSavedCaravans = JSON.parse(savedCaravans);
      setSavedItems(parsedSavedCaravans.map(item => item.id));
    }
  }

  const isSaved = (id) => {
    const items = getItems();
    return items && items.length > 0 ? (findIndex(items, { id: id} ) !== -1 ? true : false) : false
  }

  const handleSave = (item) => {

    const id = get(item, 'layoutId', null);

    const data = {
      title: item.title,
      image: item.image,
      uri: get(item, 'uri', null)
    }

    const saved = isSaved(id);

    (id && saved) ? removeItem({type: 'floorplan', id, data}) : saveItem({type: 'floorplan', id, data});

    // setSavedItems(savedItems.concat([id])) // Just so we can reload the saved items from ls

  }

  const handleFilterChange = (state, index) => {
    const newQsData = state.map(item => {
      return {
        range: item.rangeId,
        series: item.seriesId,
        spec: item.specTitle,
        model: item.layoutId
      }
    })
    const qsData = {items: newQsData}
    updateFilters(qsData, index);
    const param = qs.stringify(qsData);
    localStorage.setItem('compare', JSON.stringify(qsData));
    triggerLsEvent();
    window.history.pushState('', '', `?${param}`);
  }

  const handleViewing = (obj) => {

    const viewItemIndex = findIndex(viewItems, obj)
    if (viewItemIndex === -1) {
      const newState = produce(viewItems, draft => {
        draft.push(obj);
      });
      setViewItems(newState)
    } else {
      const newState = produce(viewItems, draft => {
        draft.splice(viewItemIndex, 1);
      });
      setViewItems(newState)
    }
  }

  const requestViewingLink = '/get-a-quote?' + qs.stringify({items: viewItems});

  const handleViewingClick = () => {
    dlPush({
      'event': 'jaycoEvent',
      'eventAction': 'CTA Click - Request a quote',
      'eventCategory': 'Research',
      'eventLabel': '/compare',
    })
  }

  const handleModelSelect = (model) => {
    const defaultModel = get(model, 'models[0]', model)

    const nextState = produce(modelsOfInterest, draftState => {
      if (changeIndex !== null) {
        draftState[changeIndex] = defaultModel;
      } else {
        draftState.push(defaultModel)
      }
    })

    setChangeIndex(null)
    setModelsOfInterest(nextState)
    handleFilterChange(nextState, changeIndex);
    setModal(false)
  }

  const handleModelChange = (index, value) => {
    const itemRangeId = modelsOfInterest[index].rangeId;
    const itemSeriesTitle = modelsOfInterest[index].seriesTitle;
    const modelRange = props.modelOverlay.find(item => item.id === itemRangeId);
    const modelSeries = modelRange ? modelRange.models.find(item => item.seriesTitle === itemSeriesTitle) : null;
    const selectedModel = modelSeries ? modelSeries.models.find(item => item && (item.layoutId === value.value)) : null
    if (!selectedModel) {
      return;
    }
    const nextState = produce(modelsOfInterest, draftState => {
      draftState[index] = selectedModel;
    })
    setModelsOfInterest(nextState);
    handleFilterChange(nextState, index);
  }

  const onRemoveModel = (index) => {
    const nextState = produce(modelsOfInterest, draftState => {
      draftState.splice(index, 1);
    })
    setModelsOfInterest(nextState)
    updateFilters(nextState, index)
    handleFilterChange(nextState, index);
  }

  const handleChange = (index) => {
    setModal(true);
    setChangeIndex(index);
  }

  const cellWidth = isWidthUp('lg', props.width) ? '345px' : '280px';

  const filteredRangeOverlayProps = filterOverlayProps(props.modelOverlay, modelsOfInterest);

  const displayModelsOfInterest = isWidthUp('lg', props.width) ? modelsOfInterest : produce(modelsOfInterest, draft => {
    draft.splice(2, 1);
  });

  const displayCompareItems = isWidthUp('lg', props.width) ? compareItems : produce(compareItems, draft => {
    draft.splice(2, 1);
  });
  

  console.log('displayCompareItems', displayCompareItems, displayModelsOfInterest);

  return (
  	<Container>
        {pricingModal &&
            <PostcodePopup
                open={true}
                onClose={() => {
                    setPricingModal(false);
                    setPricingKey('priceAUNSW');
                    const data = {
                      postcode: 2000
                    }
                    localStorage.setItem('userLocation', JSON.stringify(data));
                }}
                onSubmit={(postcode) => {
                  const key = pricingKey ? pricingKey : getPriceKey(postcode);
                  setPricingKey(key);
                  setPricingModal(false);
              }}
            />
        }
        <>
          <ModelSelectModal
            open={modal}
            onSelect={handleModelSelect}
            handleModal={setModal}
            ranges={filteredRangeOverlayProps}
          />
          <Grid container direction={'row'} justify={'space-between'} align={'center'}>
            <Grid item xs={12}>
              <Text variant="h2" colour="charcoal" uppercase align="center">Compare</Text> 
            </Grid>
          </Grid>
          <TabsWrapper>
            <Grid container direction={'row'} justify={'space-between'} align={'center'}>
              <Grid item xs={12}>
                <TabsContainer>
                  <Tabs
                    value={modelView}
                    data={[{title: 'Exterior view'}, {title: 'Floor plan view'}]}
                    variant="standard"
                    onChange={(e) => setModelView(e)}
                  />
                </TabsContainer>
              </Grid>
            </Grid>
          </TabsWrapper>
          <CompareModels itemLength={displayCompareItems.length}>
            <Box px={2}>
              <Grid container direction={'row'} justify={displayModelsOfInterest.length === 0 ? 'center' : 'flex-end'}>
              
                {displayModelsOfInterest.map((item, index) => {
                  // const ranges = props.ranges.filter(range => range.title === item.range);              
                  // const modelData = get(item, `specs[${item.specIndex}].models`, [])
                  // const models = refactorFloorplanSizes(modelData, item.range);
                  const img = modelView === 0 ? get(item, 'image' , item.image) : get(item, 'floorPlanImg' , item.image);

                  const itemRange = get(props, 'modelOverlay', []).find(range => range.title === item.rangeTitle);
                  const itemSeries = get(itemRange, 'models', []).find(series => series.seriesTitle === item.seriesTitle);
                  
                  const relatedModels = itemSeries && itemSeries.models ? itemSeries.models.map(item => {
                    return {
                      value: item.layoutId,
                      text: item.size
                    }
                  }).filter(i => {
                    return ((!displayModelsOfInterest.find(j => j.layoutId === i.value) || i.value === item.layoutId)) ? true : false
                  }) : []

                  // console.log('relatedModels', relatedModels);
                  // console.log('relatedModels models', itemSeries.models);
                  // console.log('relatedModels displayModelsOfInterest', displayModelsOfInterest);

                  return (
                    <CaravanCardItem key={item.uniqueId}>
                      <CaravanCardContainer>
                        <Edit>
                          <Close>
                            <ButtonBase onClick={() => onRemoveModel(index)}>
                              <ReactSVG src={close} />
                            </ButtonBase>
                          </Close>
                          <Links svg={chevronRightIcon}  onClick={() => handleChange(index)}>
                            change
                          </Links>
                        </Edit>
                        <CaravanFilter
                          hideImgMobile={true}
                          title={item.seriesTitle}
                          image={img}
                          sleepsStandard={get(item, 'sleepsStandard', null)}
                          sleepsOptional={get(item, 'sleepsOptional', null)}
                          layoutId={get(item, 'layoutId', null)}
                          saved={savedItems.indexOf(get(item, 'layoutId', null)) !== -1 ? true : false }
                          onSave={() => handleSave(item)}
                          onChange={(type, value) => handleModelChange(index, value)}
                          getPrice={get(item, 'hidePricing', null) === true ? false : true}
                          uri={get(item, 'uri', null)}
                          pricingKey={pricingKey}
                          filters={{
                            size: {
                              label: 'Size',
                              value: get(item, 'layoutId', null),
                              options: orderBy(relatedModels, ['text'],['asc'])
                            }
                          }}
                        />
                      </CaravanCardContainer>
                    </CaravanCardItem>
                    ) 
                  }
                )}
              
                {(displayModelsOfInterest && (displayModelsOfInterest.length < maxToCompare)) && 
                  <CaravanCardItem>
                    <Blank>
                      <Add onClick={() => setModal(true)}>
                        <Links svg={enlargeIcon}>
                          Add Model
                        </Links>
                      </Add>
                      <img src={blank} alt="blank caravan" />
                    </Blank>
                  </CaravanCardItem>
                }
              </Grid>
            </Box>
          </CompareModels>
          {displayCompareItems.length > 0 &&
          <CompareTableContainer itemLength={displayCompareItems.length}>
            <Grid container className="hasPadding" direction={'row'} justify={'space-between'} align={'left'}>
              <Grid item xs={12}>
                <Box px={2}>
                  <CompareTable 
                    items={displayCompareItems}
                    width={props.width}
                    cellWidth={cellWidth}
                    showBlankCell={displayModelsOfInterest && (displayModelsOfInterest.length < maxToCompare) ? true : false}
                  />
                  
                  {!isWidthUp('md', props.width) &&
                    <>
                      <CompareTableFooter mobile={1}>

                        {displayCompareItems.map(item => {
                          const obj = setViewObj(item);
                          return (
                            <CompareTableFooterCell checkbox={1} key={item.uniqueId}>
                              <Checkbox
                                label="Add to quote list"
                                checked={findIndex(viewItems, obj) === -1 ? false : true}
                                onChange={(event) => handleViewing(obj)}
                                name='add_to_viewing_list_mobile'
                              />
                            </CompareTableFooterCell>
                          )
                        })}

                      </CompareTableFooter>
                      <CompareTableFooterCta>
                        <Cta
                          inline
                          href={requestViewingLink}
                          onClick={handleViewingClick}
                        >
                          Get a quote
                        </Cta>
                      </CompareTableFooterCta>
                    </>
                  }

                  <CompareTableFooter>

                    <CompareTableFooterCell fullWidth={!isWidthUp('md', props.width) ? 1 : 0}>
                      <LinkItems>
                        {/* <LinkItem>
                          <Links href="#" svg={printSvg} stroke onClick={() => window.print()}>
                            PRINT
                          </Links>
                        </LinkItem> */}
                        {/* <LinkItem>
                          <Links href="#" svg={saveSvg} stroke>
                            SAVE
                          </Links>
                        </LinkItem> */}
                        <SocialShare/>
                      </LinkItems>
                    </CompareTableFooterCell>

                    {isWidthUp('md', props.width) &&
                      displayCompareItems.map((item, index) => {
                        const obj = setViewObj(item);
                        return (
                          <CompareTableFooterCell key={item.uniqueId}>
                            <Checkbox
                              label="Add to quote list"
                              checked={findIndex(viewItems, obj) === -1 ? false : true}
                              onChange={(event) => handleViewing(obj)}
                              // onChange={(event) => updateChecked(event.target.checked)}
                              name='add_to_viewing_list_desktop'
                            />
                            {(index + 1) === displayCompareItems.length &&
                              <CompareTableCta>
                                <Cta
                                  inline
                                  href={requestViewingLink}
                                  onClick={handleViewingClick}>
                                  Get a quote
                                </Cta>
                              </CompareTableCta>
                            }
                          </CompareTableFooterCell>
                        )
                      })
                    }
                    {displayModelsOfInterest && (displayModelsOfInterest.length < maxToCompare) &&
                      <CompareTableFooterCell>&nbsp;</CompareTableFooterCell>
                    }
                  </CompareTableFooter>
                </Box>
              </Grid>
            </Grid>
          </CompareTableContainer>
          }
        </>
      {/* } */}
    </Container>
  )
}
  
Compare.propTypes = {
}
  
Compare.defaultProps = {
}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_PAGE_CONTEXT = gql`
    query GET_PRESS_PAGE {
      pageBy(uri: "compare") {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        uri
      }
    }
  `

  const GET_COMPARE = gql`
    query GET_COMPARE($uri: String)  {
      rangeListingsPageBy(uri: $uri) {
        ${contentBuilderQuery('RangeListingsPage_AcfContentBuilder')}
      }
      modelsFloorPlans(first: 10000) {
        nodes {
          title
          uri
          id
          acf_floor_plan {
            modelHidePricing
            seriesSpec
            modelLayoutId
            modelLayoutName
            modelSleepsAdult
            modelSleepsChild
            modelSleepsOptional
            modelFeatures
            modelBodyLength
            modelInteriorHeight
            modelOpenLength
            modelFrontBedWidth
            modelRearBedWidth
            modelTravelHeight
            modelTravelLength
            modelTravelWidth
            modelWidthIncAwning
            modelExternalImagesRep {
              modelExternalImagesRepImage {
                ${respImgQuery}
              }
            }
            modelFloorPlanImage {
              ${respImgQuery}
            }
            modelSeries {
              ... on Series {
                id
                uri
                acf_series {
                  seriesHidePricing
                  seriesRange {
                    ... on Range {
                      uri
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      ranges(first: 10000) {
        nodes {
          title
          id
          rangeId
          uri
          acf_range {
            rangeSeriesRef {
              ... on Series {
                id
                seriesId
                title
                uri
                acf_series {
                  seriesImage {
                    altText
                    mediaDetails {
                      sizes {
                        width
                        sourceUrl
                        name
                        height
                      }
                    }
                  }
                  seriesHidePricing
                  seriesSpecsRep {
                    id
                    seriesSpecRepTitle
                  }
                }
              }
            }
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  const pageProps = await client.query({
    query: GET_COMPARE,
    variables: {
      uri: 'range' + '?' + countryCode // add country code query string
    }
  });

  const context = get(contextProps, 'data.pageBy', null);
  const assignedDomains = get(context, 'acf_domains.assignedDomains', []);

  const data = refactorCompareData(pageProps) 

  // breadcrumbs
  const breadcrumbs = await refactorBreadcrumbsData('/compare', assignedDomains);

  return {
    props: {
      meta: {
        title: get(context, 'title', null),
        seo: get(context ,'seo', null),
        assignedDomains
      },
      breadcrumbs,
      marginTop: false,
      ...data,
      greyBg: true
    }
  }
}

export default withWidth(Compare)
